import Vue from 'vue';
import Vuex from 'vuex';

// Modules

import app from "./app";
import appConfig from "./app-config";
import authModule from "./auth";
import verticalMenu from './vertical-menu';
import leadModule from './lead';
import equipmentModule from './equipment';
import customerModule from './customers';
import invoiceModule from './invoices';
import labourModule from './labour';
import supplierModule from './suppliers';
import salesOrderModule from './salesorders';
import purchaseOrderModule from './purchaseorder';
import purchaseInvoiceModule from './purchaseinvoice';
import rawmaterialModule from './RawMaterial';
import salesPersonModule from './SalesPerson';
import itemcategoryModule from './ItemCategory';
import itemUomModule from './ItemUOM';
import moduleConfig from './moduleConfig';
import productModule from './product';
import contactModule from './contact';
import jobcardModule from './jobcard';
import quotationModule from './quotation'
import userModule from './users';
import pushModule from './pushorder';
import roleModule from './roles';
import tenantModule from './tenants';
import reportModule from './reports';
import ticketModule from './tickets';
import inventoryTransactionModule from './transaction';
import warehouseModule from './warehouse';
import personalModule from './personal';
import notificationModule from './notification';
import serviceModule from './servicerequests';
import paymentModule from './payments';
import itemBalanceModule from './itemBalance'
import deliveryModule from './deliverynotes'
import marketingModule from './marketing'
import moduleModule from './module'
import fileModule from './file'
import noteModule from './note'
import opportunityModule from './opportunity';
import complaintModule from './complaints';
import marketingleadsModule from './marketingleads';
import campaignModule from './campaign';
import emailtemplate from './emailtemplate';
import segmentModule from './segments';
import emailcampaign from './emailcampaign';
import projectModule from './project';
import chartofaccountModule from './chartofaccount';
import bankModule from './bank';
import bankStatementModule from './bankStatement';
import incomeModule from './income';
import expenseModule from './expense';
import budgetModule from './budget';
import metricModule from './metrics';
import journalentryModule from './journalentry';
import journalentrylineModule from './journalentryline';
import taxModule from './tax';
import employeeModule from './employee';
import departmentModule from './departments';
import allocationModule from './allocation';
import designationModule from './designation';
import deliveriesModule from './delivery';
import gpsModule from './gps'
import vehicleModule from './vehicle'
import distributionModule from './distribution'
import itemModule from './item'
import documentModule from './documentrepo';
import filesharingModule from './filesharing';
import timesheetModule from './timesheet'
import leavetypeModule from './leavetype';
import leaverequestModule from './leaverequest';
import customFieldsModule from './customFields';
import leavebalanceModule from './leaveBalance';
import taskModule from './task';
import projectCostModule from './cost'
import performancerecordModule from './performancerecord';
import eventModule from './event';
import batchProductionModule from './batchProduction';
import websiteBuilderModule from './websitebuilder';
import selfserviceModule from './selfservice';
import employeeTrainingModule from './employeeTraining';
import attendanceModule from './attendance';
import ecommerceModule from './ecom';
import elearnModule from './elearn';
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    authModule,
    leadModule,
    equipmentModule,
    customerModule,
    invoiceModule,
    labourModule,
    supplierModule,
    salesOrderModule,
    purchaseOrderModule,
    rawmaterialModule,
    itemcategoryModule,
    itemUomModule,
    moduleConfig,
    productModule,
    salesPersonModule,
    contactModule,
    jobcardModule,
    quotationModule,
    userModule,
    pushModule,
    roleModule,
    tenantModule,
    reportModule,
    ticketModule,
    inventoryTransactionModule,
    warehouseModule,
    personalModule,
    notificationModule,
    serviceModule,
    paymentModule,
    itemBalanceModule,
    deliveryModule,
    marketingModule,
    moduleModule,
    fileModule,
    noteModule,
    opportunityModule,
    complaintModule,
    marketingleadsModule,
    campaignModule,
    emailtemplate,
    segmentModule,
    emailcampaign,
    projectModule,
    chartofaccountModule,
    bankModule,
    bankStatementModule,
    incomeModule,
    expenseModule,
    budgetModule,
    metricModule,
    journalentryModule,
    journalentrylineModule,
    taxModule,
    departmentModule,
    employeeModule,
    allocationModule,
    designationModule,
    deliveriesModule,
    gpsModule,
    vehicleModule,
    distributionModule,
    documentModule,
    itemModule,
    timesheetModule,
    filesharingModule,
    leavetypeModule,
    leaverequestModule,
    customFieldsModule,
    leavebalanceModule,
    taskModule,
    projectCostModule,
    performancerecordModule,
    eventModule,
    purchaseInvoiceModule,
    batchProductionModule,
    websiteBuilderModule,
    selfserviceModule,
    employeeTrainingModule,
    attendanceModule,
    ecommerceModule,
    elearnModule
  },
  strict: process.env.DEV,
});
